import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import { Add as AddIcon } from '@mui/icons-material';

/**
 * Composant réutilisable pour afficher un état vide
 * @param {Object} props - Les props du composant
 * @param {string} props.title - Titre de l'état vide
 * @param {string} props.description - Description de l'état vide
 * @param {string} props.actionLabel - Texte du bouton d'action (optionnel)
 * @param {Function} props.onAction - Fonction appelée au clic sur le bouton d'action
 * @param {JSX.Element} props.icon - Icône à afficher (optionnel)
 * @returns {JSX.Element}
 */
const EmptyState = ({ 
  title, 
  description, 
  actionLabel,
  onAction,
  icon
}) => {
  return (
    <Box 
      textAlign="center" 
      sx={{ 
        mt: 4, 
        mb: 4,
        p: 4,
        maxWidth: 400,
        mx: 'auto'
      }}
    >
      {icon && (
        <Box sx={{ mb: 2, color: 'text.disabled' }}>
          {icon}
        </Box>
      )}
      
      <Typography 
        variant="h6" 
        color="text.secondary" 
        gutterBottom
        sx={{ fontWeight: 500 }}
      >
        {title}
      </Typography>
      
      <Typography 
        variant="body2" 
        color="text.secondary"
        sx={{ mb: 3, lineHeight: 1.6 }}
      >
        {description}
      </Typography>

      {actionLabel && onAction && (
        <Button
          variant="contained"
          startIcon={<AddIcon />}
          onClick={onAction}
          sx={{ mt: 1 }}
        >
          {actionLabel}
        </Button>
      )}
    </Box>
  );
};

export default EmptyState;